import { saveAs } from 'file-saver';

const download = saveAs;

export default download;
